import { Fragment } from "react/jsx-runtime";
import HeroSection from "../components/common/HeroSection";
import data from "../services.json";
import FAQ from "../components/Services/FAQSection";
import WhatweOffer from "../components/Services/WhatWeOffer";
import CTASection from "../components/common/CTASection";
import ClinicBanner from "../components/Services/ClinicBanner";
import DigitalHealthFAB from "../components/Digitalhealth";

const { services } = data;

const Services = () => {
    const heroSlides = [services.hero];
  return (
    <Fragment>
      <DigitalHealthFAB/>
        <HeroSection slides={heroSlides} />
        <WhatweOffer /> 
        <ClinicBanner data={data.clinicBanner} />
       <FAQ />
       <CTASection data={data.callToAction} />
    </Fragment>
  );
};

export default Services;